import { Service } from './models';

export interface Plan {
  name: string;
  slug: string;
  trialDaysLeft?: number;
  interval: string;
  pricePerMember: number;
  upgradeProductName?: string;
  isActive: boolean;
  isFreePlan: boolean;
  maxPlanUsers: number;
  service: Service | null;
  canSendTeamInvites: boolean;
}

export enum TestimonialPlanSlugs {
  FreeMonthly = 'tm-free-monthly-2023',
  FreeYearly = 'tm-free-yearly-2023',
  ProMonthly = 'tm-pro-monthly-2023',
  ProYearly = 'tm-pro-yearly-2023',
}

export enum DefaultFreeTestimonialPlanSlugs {
  FreeMonthly = TestimonialPlanSlugs.FreeMonthly,
  FreeYearly = TestimonialPlanSlugs.FreeYearly,
}

export enum DefaultPaidTestimonialPlanSlugs {
  ProMonthly = TestimonialPlanSlugs.ProMonthly,
  ProYearly = TestimonialPlanSlugs.ProYearly,
}

export enum VideoMessagingPlanSlugs {
  FreeMonthly = 'vm-free-monthly-2023',
  FreeYearly = 'vm-free-yearly-2023',
  StarterMonthly = 'vm-starter-monthly-2023',
  StarterYearly = 'vm-starter-yearly-2023',
  ProMonthly = 'vm-pro-monthly-2023',
  ProYearly = 'vm-pro-yearly-2023',
  GrrrowthYearly = 'vm-grrrowth-yearly-2023',
  GrrrowthMonthly = 'vm-grrrowth-monthly-2023',
  CompanyYearly = 'vm-company-yearly-2023',
  CompanyMonthly = 'vm-company-monthly-2023',
}

export enum ShopifyVideoMessagingPlanSlugs {
  FreeMonthly = 'vm-free-monthly-2023-shopify',
  FreeYearly = 'vm-free-yearly-2023-shopify',
  StarterMonthly = 'vm-starter-monthly-2023-shopify',
  StarterYearly = 'vm-starter-yearly-2023-shopify',
  ProMonthly = 'vm-pro-monthly-2023-shopify',
  ProYearly = 'vm-pro-yearly-2023-shopify',
  GrrrowthYearly = 'vm-grrrowth-yearly-2023-shopify',
  GrrrowthMonthly = 'vm-grrrowth-monthly-2023-shopify',
  CompanyYearly = 'vm-company-yearly-2023-shopify',
  CompanyMonthly = 'vm-company-monthly-2023-shopify',
}

export enum DefaultFreeVideoMessagingPlanSlugs {
  FreeMonthly = VideoMessagingPlanSlugs.FreeMonthly,
  FreeYearly = VideoMessagingPlanSlugs.FreeYearly,
}

export enum DefaultPaidVideoMessagingPlanSlugs {
  ProMonthly = VideoMessagingPlanSlugs.ProMonthly,
  ProYearly = VideoMessagingPlanSlugs.ProYearly,
}

/**
 * This is only for backward compatibility.
 * Once the new plans are released and stable this should be deleted
 * and cleanup.
 * https://bonjoro.atlassian.net/browse/PLG-586
 */

export enum SoloPlanSlugs {
  StarterMonthly = 'starter-2022-solo-monthly',
  StarterYearly = 'starter-2022-solo-yearly',
  ProMonthly = 'pro-2022-solo-monthly',
  ProYearly = 'pro-2022-solo-yearly',
  GrrrowthMonthly = 'grrrowth-2022-solo-monthly',
  GrrrowthYearly = 'grrrowth-2022-solo-yearly',
}

export enum TeamPlanSlugs {
  StarterMonthly = 'starter-2022-monthly',
  StarterYearly = 'starter-2022-yearly',
  ProMonthly = 'pro-2022-monthly',
  ProYearly = 'pro-2022-yearly',
  GrrrowthMonthly = 'grrrowth-2022-monthly',
  GrrrowthYearly = 'grrrowth-2022-yearly',
  CompanyMonthly = 'company-2022-monthly',
  CompanyYearly = 'company-2022-yearly',
}

export enum BonjoroService {
  VideoMessaging = 'video_messaging',
  Testimonials = 'testimonials',
}
